module.exports = __webpack_public_path__ + "static/media/buzzumo2.06f175a8.png";